module.exports = __webpack_public_path__ + "media/application/images/playbook-hero-bg-8f683b4d0204033bef9b848e1b9d4670.webp";